"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultMap = exports.mapFilterUndefined = exports.hasOwnProperty = exports.definedMap = exports.reduceTwo = exports.sleep = exports.dontAwait = exports.defined = exports.assertNever = exports.assert = exports.panic = exports.proveNever = exports.proveType = void 0;
function proveType(_val) {
    // do nothing, just prove the compiler thinks the types match
}
exports.proveType = proveType;
function proveNever(_never, message, result) {
    console.trace(message);
    return result;
}
exports.proveNever = proveNever;
function panic(message = "This should not happen") {
    console.trace(message);
    throw new Error(message);
}
exports.panic = panic;
function assert(fact, message = "Assertion failed") {
    if (fact)
        return;
    return panic(message);
}
exports.assert = assert;
function assertNever(_never) {
    return panic("Hell froze over");
}
exports.assertNever = assertNever;
function defined(v, reason) {
    if (v === undefined)
        return panic("Value was undefined but should be defined" +
            (reason !== undefined ? `, expected to be defined because: ${reason}` : ""));
    return v;
}
exports.defined = defined;
function dontAwait(p) {
    p.catch(e => {
        console.error("Unhandled error from unawaited promise", e);
        throw e;
    });
}
exports.dontAwait = dontAwait;
function sleep(ms) {
    return new Promise(resolve => {
        setTimeout(resolve, ms);
    });
}
exports.sleep = sleep;
function reduceTwo(a, b, f) {
    if (a === undefined)
        return b;
    if (b === undefined)
        return a;
    return f(a, b);
}
exports.reduceTwo = reduceTwo;
function definedMap(x, f) {
    if (x === undefined)
        return undefined;
    return f(x);
}
exports.definedMap = definedMap;
function hasOwnProperty(obj, name) {
    if (obj === undefined || obj === null)
        return false;
    return Object.prototype.hasOwnProperty.call(obj, name);
}
exports.hasOwnProperty = hasOwnProperty;
function mapFilterUndefined(iterable, f) {
    const result = [];
    let i = 0;
    for (const x of iterable) {
        const y = f(x, i);
        i += 1;
        if (y === undefined)
            continue;
        result.push(y);
    }
    return result;
}
exports.mapFilterUndefined = mapFilterUndefined;
var default_map_1 = require("./default-map");
Object.defineProperty(exports, "DefaultMap", { enumerable: true, get: function () { return default_map_1.DefaultMap; } });
//# sourceMappingURL=index.js.map